import React from "react";
import Linkify from 'react-linkify'
import ReactHtmlParser from 'react-html-parser'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faTicketAlt } from '@fortawesome/free-solid-svg-icons';
// import './Loader.scss'

export default function ShowInfo(props) {
    const { show, type, tickets } = props;

    const linkifyComponentDecorator = (href, text, key) => (
        <a href={href} key={key} target="_blank">
            {text}
        </a>
    );
    
    // Check if these are registration tickets
    const isRegistrationTicket = tickets && tickets.length > 0 && tickets[0].payment_type && tickets[0].payment_type.includes('REGISTRATION')
    
    if (type === 'about' && show.description) {
        return (
            <div className="show-section-card show-section-card--about">
                <div className="show-section-card__header"><FontAwesomeIcon icon={faInfoCircle} /> Sobre el evento</div>
                <div className="show-section-card__body"> <><Linkify componentDecorator={linkifyComponentDecorator}>{ReactHtmlParser(show.description)}</Linkify></></div>
            </div>
        );
    }
    if (type === 'important') {
        return (
            <div className="show-section-card show-section-card--important">
                <div className="show-section-card__header"><FontAwesomeIcon icon={faTicketAlt} /> Información importante</div>
                <div className="show-section-card__body">
                    {tickets && tickets.length > 0 && (
                        <div className="show-info-tickets">
                            {tickets.map(t => (
                                <div key={t._id} className="show-info-ticket-row">
                                    <span>{t.fullname}</span>
                                    <span>{isRegistrationTicket ? "Acceso gratuito" : (t.currency === 'USD' ? t.price_usd_text : t.price_text)}</span>
                                </div>
                            ))}
                        </div>
                    )}
                    {show.important_info && <div>{show.important_info}</div>}
                </div>
            </div>
        );
    }
    return null;
}